import { createAsyncThunk } from "@reduxjs/toolkit";
import ProductService from "../../../services/productServices";

export const fetchProducts = createAsyncThunk(
  "fetchProducts",
  async (arg, thunkAPI) => {
    try {
      const response = await ProductService.getProducts();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchProductDetails = createAsyncThunk(
  "fetchProductDetails",
  async (id, thunkAPI) => {
    try {
      const response = await ProductService.getProduct(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);